import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { RequiredInterfaces, RootStorageFilesInterface, UpdateInterface } from '../interfaces';
import { ReloadInterface } from '../interfaces/ReloadInterface';
import { Permission } from '../Permissions';
import { Feature, hasUrlQueryFeature, isUrlQueryPlatform } from '../PlatformCheck';
import { PlayerPmc } from '../PlayerPmc';
import { ReachPmcInterface } from './ReachPmcInterface';
import { Error as PlatformError } from '../Platform';

export class ReachPmcPlayer
    extends PlayerPmc
    implements
        RequiredInterfaces,
        ReachPmcInterface,
        RootStorageFilesInterface,
        ReloadInterface,
        UpdateInterface
{
    readonly name = 'REACH Player';
    constructor() {
        super();
        this.addPermission(Permission.VLC_RTP);
        this.addPermission(Permission.VLC_RTMP);
        this.addPermission(Permission.VLC_HDMI);
        this.addPermission(Permission.RELAXED_NET_SECURITY);
    }

    static isTheRunningPlatform(): boolean {
        const thisPlatformIsRunning = isUrlQueryPlatform('Reach');
        const thisPlatformSupportsPmc = hasUrlQueryFeature(Feature.PostMessageClient);
        return thisPlatformIsRunning === true && thisPlatformSupportsPmc;
    }

    async _generateAndGetHardwareId(): Promise<string> {
        const { uniqueIdentifier } = await this.postMessage(
            PmcMessageType.DeviceInformationGet,
            undefined
        );
        const hardwareId = uniqueIdentifier
            .split(',')
            .map((identifier) => identifier.toLocaleLowerCase())
            .sort()
            .reduce((acc, next) => acc + next, '');
        return `REACH://${hardwareId}`;
    }

    async getRemoteSupportDeviceId(): Promise<string> {
        const remoteSupportDeviceId = await this.postMessage(
            PmcMessageType.RemoteSupportDeviceIdGet,
            undefined
        );
        if (remoteSupportDeviceId !== null) {
            return remoteSupportDeviceId;
        }

        throw new PlatformError(
            'NamedValueCache key remote_support_device_id is not defined or TeamViewer instance does not belong to REACH'
        );
    }
}
